<template>
    <div id="apiDoc">
        <div class="api-menu">
            <h1>目 录</h1>
            <el-col>
                <el-menu class="el-menu-vertical-demo" default-active="1">
                    <el-menu-item index="1" @click="showView('globalParameter')">
                        <span slot="title" >全局参数</span>
                    </el-menu-item>
                    
                    <el-menu-item index="2" @click="showView('versionHistory')">
                        <span slot="title" >1 修订历史</span>
                    </el-menu-item>

                    <el-submenu index="3">
                        <template slot="title">
                          <span>2 接口说明</span>
                        </template>

                        <el-submenu index="3-1">
                          <template slot="title" >2.1 获取token</template>
                          <el-menu-item index="3-1-1" @click="showView('getToken_requestMethod')">请求方式</el-menu-item>
                          <el-menu-item index="3-1-2" @click="showView('getToken_requestExample')">请求示例</el-menu-item>
                          <el-menu-item index="3-1-4" @click="showView('getToken_responseMessage')">响应报文</el-menu-item>
                        </el-submenu>

                        <el-submenu index="3-2">
                          <template slot="title" >2.2 SIM卡信息查询</template>
                          <el-menu-item index="3-2-1" @click="showView('requestMethod')">请求方式</el-menu-item>
                          <el-menu-item index="3-2-2" @click="showView('requestExample')">请求示例</el-menu-item>
                          <el-menu-item index="3-2-3" @click="showView('responseExample')">响应示例</el-menu-item>
                          <el-menu-item index="3-2-4" @click="showView('responseMessage')">响应报文</el-menu-item>
                        </el-submenu>

                        <el-submenu index="3-3">
                          <template slot="title" >2.3 B2B充值接口</template>
                          <el-menu-item index="3-3-1" @click="showView('BtoBrequestMethod')">请求方式</el-menu-item>
                          <el-menu-item index="3-3-2" @click="showView('BtoBrequestExample')">请求示例</el-menu-item>
                          <el-menu-item index="3-3-3" @click="showView('BtoBresponseExample')">响应示例</el-menu-item>
                          <el-menu-item index="3-3-4" @click="showView('BtoBresponseMessage')">响应报文</el-menu-item>
                        </el-submenu>

                        <el-submenu index="3-4">
                          <template slot="title" >2.4 数据通信服务关停</template>
                          <el-menu-item index="3-4-1" @click="showView('ShutServeMethod')">请求方式</el-menu-item>
                          <el-menu-item index="3-4-2" @click="showView('ShutServeExample')">请求示例</el-menu-item>
                          <el-menu-item index="3-4-3" @click="showView('ShutResponseExample')">响应示例</el-menu-item>
                          <el-menu-item index="3-4-4" @click="showView('ShutResponseMessage')">响应报文</el-menu-item>
                        </el-submenu>

                        <el-submenu index="3-5">
                          <template slot="title" >2.5 实时查询卡信息</template>
                          <el-menu-item index="3-5-1" @click="showView('realTimeRequestMethod')">请求方式</el-menu-item>
                          <el-menu-item index="3-5-2" @click="showView('realTimeRequestExample')">请求示例</el-menu-item>
                          <el-menu-item index="3-5-3" @click="showView('realTimeResponseExample')">响应示例</el-menu-item>
                          <el-menu-item index="3-5-4" @click="showView('realTimeResponseMessage')">响应报文</el-menu-item>
                        </el-submenu>

                    </el-submenu>

                    <el-menu-item index="4" @click="showView('preBrower')">
                        <span slot="title" >在线预览</span>
                    </el-menu-item>


                    <el-menu-item index="5" >
                        <span slot="title">
                            <a href="../../../doc/深圳市雁云信息科技有限公司物联卡管理平台API文档.pdf" download="深圳市雁云信息科技有限公司物联卡管理平台API文档.pdf">下载API文档</a>
                        </span>
                    </el-menu-item>
                </el-menu>
            </el-col>
        </div>






        <div class="api-content">

            <!--  全局参数  -->
            <div v-show="currentView == 'globalParameter'" class="requestMethod">
                <h5 style="color: red; font-size: 20px; padding: 30px;">注意事项：API接口限制，每天轮询1到2次，间隔时间12小时，请不要频繁轮询调用接口，否则限制调用，谢谢！</h5>
                <el-table v-show="currentView == 'globalParameter'" :data="globalParameter" border style="width: 100%">
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>   
                </el-table>
            </div>

            
            

            <!--  修订历史  -->
            <el-table v-show="currentView == 'versionHistory'" :data="versionHistory" border style="width: 100%">
                <el-table-column prop="version" label="版本"> </el-table-column>
                <el-table-column prop="author" label="制作人"> </el-table-column>
                <el-table-column prop="time" label="修订日期"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>
            </el-table>

            

            <!-- getToken 请求方式  -->
            <div v-show="currentView == 'getToken_requestMethod'" class="requestMethod">
                <h5>请求方式：</h5>
                <el-table :data="getToken_requestMethod" border style="width: 100%">
                    <el-table-column prop="requestAddress" label="请求地址"> </el-table-column>
                    <el-table-column prop="requestType" label="请求方式"> </el-table-column>
                </el-table>
                <h5>请求头：</h5>
                <el-table :data="getToken_requestHeader" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>

            <!-- getToken 请求示例  -->
            <div v-show="currentView == 'getToken_requestExample'" class="requestExample">
                <!--  请求参数  -->
                <h5>请求参数：</h5>
                <el-table  :data="getToken_requestParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>

                <h5>请求示例：</h5>
                <el-table :data="getToken_requestExample" border style="width: 100%">
                    <el-table-column prop="name" label="名称"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>

            <!-- getToken 响应报文  -->
            <el-table v-show="currentView == 'getToken_responseMessage'" :data="getToken_responseMessage" border style="width: 100%">
                
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-form-item label="名称：">
                                <span>{{ props.row.name }}</span>
                            </el-form-item>
                            <el-form-item label="说明：">
                                <span v-html="props.row.htmlStr"></span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>

            </el-table>

            <!--          getToken                -->



            <!--  SIM卡信息查询 start  -->
            <!--  请求方式  -->
            <div v-show="currentView == 'requestMethod'" class="requestMethod">
                <h5>请求方式：</h5>
                <el-table :data="requestMethod" border style="width: 100%">
                    <el-table-column prop="requestAddress" label="请求地址"> </el-table-column>
                    <el-table-column prop="requestType" label="请求方式"> </el-table-column>
                </el-table>
                <h5>请求头：</h5>
                <el-table :data="requestHeader" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>

            

            <!--  响应参数  -->
            <el-table v-show="currentView == 'responseParameter'" :data="responseParameter" border style="width: 100%">
                <el-table-column prop="parameter" label="参数名"> </el-table-column>
                <el-table-column prop="type" label="参数类型"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>
            </el-table>


            <!--  请求示例  -->
            <div v-show="currentView == 'requestExample'" class="requestExample">
                <el-table :data="requestExample" border style="width: 100%">
                    <el-table-column prop="name" label="名称"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>

                <!--  请求参数  -->
                <h5>请求参数：</h5>
                <el-table  :data="requestParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>


            <!-- 响应示例 -->
            <div v-show="currentView == 'responseExample'" class="requestExample">

                <h5>响应参数：</h5>
                <el-table :data="responseParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
                <h5>响应参数 > data参数：</h5>
                <el-table :data="responseDataParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
                <h5>响应参数 > data参数 > pkgList参数：</h5>
                <el-table :data="responsePkgListParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>

            <!--  响应报文  -->
            <el-table v-show="currentView == 'responseMessage'" :data="responseMessage" border style="width: 100%">
                
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-form-item label="名称：">
                                <span>{{ props.row.name }}</span>
                            </el-form-item>
                            <el-form-item label="说明：">
                                <span v-html="props.row.htmlStr"></span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>

            </el-table>
            <!--  SIM卡信息查询 end  -->


            <!-- B2B充值接口 start -->
            <!-- 请求方式 -->
            <div v-show="currentView == 'BtoBrequestMethod'" class="requestMethod">
                <h5>请求方式：</h5>
                <el-table :data="BtoBrequestMethod" border style="width: 100%">
                    <el-table-column prop="requestAddress" label="请求地址"> </el-table-column>
                    <el-table-column prop="requestType" label="请求方式"> </el-table-column>
                </el-table>
                <h5>请求头：</h5>
                <el-table :data="BtoBrequestMethodHeader" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>
            <!--  请求示例  -->
            <div v-show="currentView == 'BtoBrequestExample'" class="requestMethod">
                <el-table :data="BtoBrequestExample" border style="width: 100%">
                    <el-table-column prop="name" label="名称"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>

                <!--  请求参数  -->
                <h5>请求参数：</h5>
                <el-table  :data="BtoBrequestParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>
            <!-- 响应示例 -->
            <div v-show="currentView == 'BtoBresponseExample'" class="requestExample">
                <h5>响应参数：</h5>
                <el-table :data="BtoBresponseParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>
            <!--  响应报文  -->
            <el-table v-show="currentView == 'BtoBresponseMessage'" :data="BtoBresponseMessage" border style="width: 100%"> 
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-form-item label="名称：">
                                <span>{{ props.row.name }}</span>
                            </el-form-item>
                            <el-form-item label="说明：">
                                <span v-html="props.row.htmlStr"></span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>
            </el-table>
            <!-- B2B充值接口 end -->


            <!-- 数据通信服务关停  start -->
            <!-- 请求方式 -->
            <div v-show="currentView == 'ShutServeMethod'" class="requestMethod">
                <h5>请求方式：</h5>
                <el-table :data="ShutServeMethod" border style="width: 100%">
                    <el-table-column prop="requestAddress" label="请求地址"> </el-table-column>
                    <el-table-column prop="requestType" label="请求方式"> </el-table-column>
                </el-table>
                <h5>请求头：</h5>
                <el-table :data="ShutServeMethodHeader" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>
            <!--  请求示例  -->
            <div v-show="currentView == 'ShutServeExample'" class="requestMethod">
                <el-table :data="ShutServeExample" border style="width: 100%">
                    <el-table-column prop="name" label="名称"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>

                <!--  请求参数  -->
                <h5>请求参数：</h5>
                <el-table  :data="ShutrequestParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>
            <!-- 响应示例 -->
            <div v-show="currentView == 'ShutResponseExample'" class="requestExample">
                <h5>响应参数：</h5>
                <el-table :data="ShutresponseParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>
            <!--  响应报文  -->
            <el-table v-show="currentView == 'ShutResponseMessage'" :data="ShutResponseMessage" border style="width: 100%">
                
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-form-item label="名称：">
                                <span>{{ props.row.name }}</span>
                            </el-form-item>
                            <el-form-item label="说明：">
                                <span v-html="props.row.htmlStr"></span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>

            </el-table>
            <!-- 数据通信服务关停  end -->


            <!--  实时查询卡信息 start  -->
            <!--  请求方式  -->
            <div v-show="currentView == 'realTimeRequestMethod'" class="requestMethod">
                <h5>请求方式：</h5>
                <el-table :data="realTimeRequestMethod" border style="width: 100%">
                    <el-table-column prop="requestAddress" label="请求地址"> </el-table-column>
                    <el-table-column prop="requestType" label="请求方式"> </el-table-column>
                </el-table>
                <h5>请求头：</h5>
                <el-table :data="realTimeRequestHeader" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>

            

            <!--  响应参数  -->
            <el-table v-show="currentView == 'realTimeResponseParameter'" :data="realTimeResponseParameter" border style="width: 100%">
                <el-table-column prop="parameter" label="参数名"> </el-table-column>
                <el-table-column prop="type" label="参数类型"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>
            </el-table>


            <!--  请求示例  -->
            <div v-show="currentView == 'realTimeRequestExample'" class="requestExample">
                <el-table :data="realTimeRequestExample" border style="width: 100%">
                    <el-table-column prop="name" label="名称"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>

                <!--  请求参数  -->
                <h5>请求参数：</h5>
                <el-table  :data="realTimeRequestParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="beMust" label="是否必须"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>


            <!-- 响应示例 -->
            <div v-show="currentView == 'realTimeResponseExample'" class="requestExample">

                <h5>响应参数：</h5>
                <el-table :data="realTimeResponseParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
                <h5>响应参数 > data参数：</h5>
                <el-table :data="realTimeResponseDataParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
                <h5>响应参数 > data参数 > pkg参数：</h5>
                <el-table :data="realTimeResponsePkgListParameter" border style="width: 100%">
                    <el-table-column prop="parameter" label="参数名"> </el-table-column>
                    <el-table-column prop="type" label="参数类型"> </el-table-column>
                    <el-table-column prop="remark" label="说明"> </el-table-column>
                </el-table>
            </div>

            <!--  响应报文  -->
            <el-table v-show="currentView == 'realTimeResponseMessage'" :data="realTimeResponseMessage" border style="width: 100%">
                
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-form-item label="名称：">
                                <span>{{ props.row.name }}</span>
                            </el-form-item>
                            <el-form-item label="说明：">
                                <span v-html="props.row.htmlStr"></span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="remark" label="说明"> </el-table-column>

            </el-table>
            <!--  实时查询卡信息 end  -->


             <!-- 预览 -->
            <div v-show="currentView == 'preBrower'">
                <el-button-group>
                <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>
                <el-button type="primary" size="mini" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-button-group>                      
                <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>
                <pdf
                :page="pageNum"
                :src="url"
                @progress="loadedRatio = $event"
                @num-pages="pageTotalNum=$event" 
                ></pdf>
            </div>
        </div>
        
        
    </div>
</template>
           

<script>
import pdf from 'vue-pdf'
export default {
    name: 'Pdf',
    components: {
        pdf,
    },
    data() {
        return {
            url: '../../../doc/行业卡API接口文档_1_.pdf',
            pageNum: 1,
            pageTotalNum: 1, //总页数
            loadedRatio: 0, // 当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成了

            currentView: 'globalParameter',

            //全局参数
            globalParameter:[
                {
                    name: '域名/domain',
                    remark: `api.szyanyun.com`,
                },
                {
                    name: 'Code',
                    remark: `状态值:200 为成功，其它均为失败`,
                },
            ],

            //修订历史
            versionHistory:[{
                version: 'V1.0.0',
                author: '徐亮',
                time: '2019/07/08',
                remark: '',
            }],


            //获取token  start
            //获取token ---> 请求方式
            getToken_requestMethod:[{
                requestAddress: '/web/api/v2/xxtx/get/token',
                requestType: 'post',
            }],

            //获取token ---> 请求头
            getToken_requestHeader:[{
                parameter: 'Content-Type',
                beMust: '是',
                type: 'string',
                remark: '请求类型： application/json',
            }],

            //获取token ---> 请求参数
            getToken_requestParameter:[
                {
                    parameter: 'accountName',
                    beMust: '是',
                    type: 'String',
                    remark: '帐号',
                },
                {
                    parameter: 'pwd',
                    beMust: '是',
                    type: 'String',
                    remark: '用户密码',
                },
            ],

            //获取token ---> 请求示例
            getToken_requestExample:[
                {
                    name: '请求报文',
                    remark: `{
                                "accountName":"bjzxydkj",
                                "pwd":"123456Aa",
                            }`,
                }
            ],


            //获取token ---> 响应报文
            getToken_responseMessage:[
                {
                    name: '成功',
                    remark: `{
                                "code": "200",
                                "message": "success",
                                "result": "成功",
                                    "data": "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiJCMUE4RTNE"
                            }`,

                    htmlStr: `<p>{</p>
                            <p>   "code": "200",</p>
                            <p>   "message": "success",</p>
                            <p>   "result": "成功",</p>
                            <p>   "data": "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiJCMUE4RTNE"</p>`,
                },

                {
                    name: '失败',
                    remark: `{
                                "code": "400",
                                "message": "帐号密码错误",
                                "result": "fail",
                                "data": null
                            }`,
                    htmlStr: `<p >{</p>
                            <p >   "code": "400",</p>
                            <p >   "message": "账号密码错误！",</p>
                            <p >   "result": "fail",</p>
                            <p >   "data":null</p>
                            <p >}</p>`,
                }
            ],
            //获取token  end



            // SIM卡信息查询参数    start 
            //请求方式
            requestMethod:[{
                requestAddress: 'web/api/v2/xxtx/sim/info',
                requestType: 'post',
            }],

            //请求头
            requestHeader:[{
                parameter: 'Content-Type',
                beMust: '否',
                type: 'string',
                remark: '请求类型： application/json',
            }],

            //请求参数
            requestParameter:[
                {
                    parameter: 'username',
                    beMust: '是',
                    type: 'String',
                    remark: '用户名',
                },
                {
                    parameter: 'password',
                    beMust: '是',
                    type: 'String',
                    remark: '用户密码',
                },
                {
                    parameter: 'iccid',
                    beMust: '是',
                    type: 'String',
                    remark: 'ICCID号',
                },
                {
                    parameter: 'sn',
                    beMust: '是',
                    type: 'String',
                    remark: '设备号',
                },
                {
                    parameter: '备注：iccid号和设备号可以同时传入，也可以传入其中一个查询SIM卡详情',
                },
            ],

            //响应参数
            responseParameter:[
                {
                    parameter: 'code',
                    type: 'String',
                    remark: '状态码 200成功， 其它均为失败',
                },
                {
                    parameter: 'message',
                    type: 'String',
                    remark: '成功/失败 信息提示语',
                },
                {
                    parameter: 'result',
                    type: 'String',
                    remark: '成功为 ，失败为fail',
                },
                {
                    parameter: 'data',
                    type: 'object',
                    remark: '成功返回响应数据，可能为空',
                },
            ],
            
            //请求示例
            requestExample:[
                {
                    name: '请求链接',
                    remark: `http://api.szyanyun.com/web/api/v2/xxtx/sim/info`,
                }
                ,
                {
                    name: '请求报文',
                    remark: `{
                                "accountName":"用户账号",
                                "pwd":"用户密码",
                                "iccid":"iccid号"
                            }`,
                }
            ],


            //响应参数data
            responseDataParameter:[
                {
                    parameter: 'intoNo',
                    type: 'String',
                    remark: '接入号',
                },
                {
                    parameter: 'iccid',
                    type: 'String',
                    remark: 'Iccid号',
                },
                {
                    parameter: 'state',
                    type: 'int',
                    remark: '卡状态：  1：沉默期，2：正常， 3：停机，  4：测试期',
                },
                {
                    parameter: 'simType',
                    type: 'int',
                    remark: '卡类型：0：独立套餐 1：流量共享',
                },
                {
                    parameter: 'totalFlow',
                    type: 'BigDecimal',
                    remark: '卡总流量 单位M，(当卡类型是流量共享，卡总流量默认为0，总流量请在套餐中查看)',
                },
                {
                    parameter: 'useFlow',
                    type: 'BigDecimal',
                    remark: '卡当月使用流量,单位M',
                },
                {
                    parameter: 'remainsFlow',
                    type: 'BigDecimal',
                    remark: '卡总流量 单位M，(当卡类型是流量共享，卡总流量默认为0，总流量请在套餐中查看)',
                },
                {
                    parameter: 'activationrTime',
                    type: 'String',
                    remark: '卡激活时间',
                },
                {
                    parameter: 'expireTime',
                    type: 'String',
                    remark: '卡过期时间',
                },
                {
                    parameter: 'pkgList',
                    type: 'String',
                    remark: '卡套餐相关信息',
                }
            ],


            //参数pkgList
            responsePkgListParameter:[
                {
                    parameter: 'id',
                    type: 'String',
                    remark: '套餐实例id',
                },
                {
                    parameter: 'intoNo',
                    type: 'String',
                    remark: '接入号',
                },
                {
                    parameter: 'iccid',
                    type: 'String',
                    remark: 'iccid号',
                },
                {
                    parameter: 'totalFlow',
                    type: 'String',
                    remark: '套餐总流量，单位M',
                },
                {
                    parameter: 'useFlow',
                    type: 'String',
                    remark: '已使用流量，单位M',
                },
                {
                    parameter: 'remainsFlow',
                    type: 'String',
                    remark: '剩余流量，单位M',
                },
                {
                    parameter: 'prodid',
                    type: 'String',
                    remark: '套餐id',
                },
                {
                    parameter: 'prodname',
                    type: 'String',
                    remark: '套餐名称',
                },
                {
                    parameter: 'prodinstid',
                    type: 'String',
                    remark: '套餐组id',
                }
            ],




            //响应报文
            responseMessage:[
                {
                    name: '成功',
                    remark: `{"code": "200","message": "成功","result": "success",
                                "data":{
                                    "intoNo": "123456789",
                                    "iccid": "8986045916123456789",
                                    "state": 1,
                                    "totalFlow": 100,
                                    "useFlow": 0,
                                    "remainsFlow": 100,
                                    "activationrTime": null,
                                    "expireTime": null,
                                    "simType": 0,
                                    "pkgList": [
                                        {
                                            "id": "1176295433710858240",
                                            "intoNo": "1440597724695",
                                            "iccid": "89860459161990794695",
                                            "totalFlow": 100,
                                            "useFlow": 0,
                                            "remainsFlow": 100,
                                            "prodid": "I000101011213105",
                                            "prodname": "测试8元套餐",
                                            "prodinstid": "03843213129521827"
                                        }
                                    ]
                                }
                            }`,

                    htmlStr: `<p>{</p>
                            <p>   "code": "200",</p>
                            <p>   "message": "成功",</p>
                            <p>   "result": "success",</p>
                            <p>   "data": {</p>
                            <p>      "intoNo": "123456789",</p>
                            <p>      "iccid": "8986045916123456789",</p>
                            <p>      "state": 1,</p>
                            <p>      "totalFlow": 100,</p>
                            <p>      "useFlow": 0,</p>
                            <p>      "remainsFlow": 100,</p>
                            <p>      "activationrTime": null,</p>
                            <p>      "expireTime": null,</p>
                            <p>      "simType": 0,</p>
                            <p>      "pkgList": [</p>
                            <p>         {</p>
                            <p>            "id": "1176295433710858240",</p>
                            <p>            "intoNo": "1440597724695",</p>
                            <p>            "iccid": "89860459161990794695",</p>
                            <p>            "totalFlow": 100,</p>
                            <p>            "useFlow": 0,</p>
                            <p>            "remainsFlow": 100,</p>
                            <p>            "prodid": "I000101011213105",</p>
                            <p>            "prodname": "测试8元套餐",</p>
                            <p>            "prodinstid": "03843213129521827"</p>
                            <p>         }</p>
                            <p>      ]</p>
                            <p>   }</p>
                            <p>}</p>`,
                },

                {
                    name: '失败',
                    remark: `{
                            "code": "40010",
                            "message": "账号密码错误！",
                            "result": "fail",
                            "data":null
                            }`,
                    htmlStr: `<p >{</p>
                            <p >   "code": "40010",</p>
                            <p >   "message": "账号密码错误！",</p>
                            <p >   "result": "fail",</p>
                            <p >   "data":null</p>
                            <p >}</p>`,
                }
            ],
            // SIM卡新卡查询参数  end



            // B2B充值接口   start
            //请求方式
            BtoBrequestMethod:[{
                requestAddress: 'web/api/v2/xxtx/sim/order/insert',
                requestType: 'post',
            }],
            //请求头
            BtoBrequestMethodHeader:[{
                parameter: 'Content-Type',
                beMust: '是',
                type: 'string',
                remark: '请求类型： application/json',
            }],
            //请求示例
            BtoBrequestExample:[
                {
                    name: '请求链接',
                    remark: `http://api.szyanyun.com/web/api/v2/xxtx/sim/order/insert`,
                }
                ,
                {
                    name: '请求报文',
                    remark: `{
                                "orderId":"第三方支付单号",
                                "price":"价格/分",
                                "iccid":"iccid号"
                            }`,
                }
            ],
            //请求参数
            BtoBrequestParameter:[
                {
                    parameter: 'orderId',
                    beMust: '是',
                    type: 'String',
                    remark: '第三方支付单号',
                },
                {
                    parameter: 'price',
                    beMust: '是',
                    type: 'long',
                    remark: '价格/分',
                },
                {
                    parameter: 'iccid(多个iccid，请以 , 号隔开)',
                    beMust: '是',
                    type: 'String',
                    remark: '8986112027203084050,8986112027203084051',
                },
                {
                    parameter: 'remark',
                    beMust: '否',
                    type: 'String',
                    remark: '备注',
                },
            ],
            //响应参数
            BtoBresponseParameter:[
                {
                    parameter: 'code',
                    type: 'String',
                    remark: '状态码 200成功， 其它均为失败',
                },
                {
                    parameter: 'message',
                    type: 'String',
                    remark: '成功/失败 信息提示语',
                },
                {
                    parameter: 'result',
                    type: 'String',
                    remark: '成功为 ，失败为fail',
                },
                {
                    parameter: 'data',
                    type: 'object',
                    remark: '成功返回响应数据，可能为空',
                },
            ],
            //响应报文
            BtoBresponseMessage:[
                {
                    name: '成功',
                    remark: `{"code": "200","message": "success","result": "成功","data"{"order_no": "OTHER202012180000001446"}
                            }`,

                    htmlStr: `<p>{</p>
                            <p>   "code": "200",</p>
                            <p>   "message": "success",</p>
                            <p>   "result": "成功",</p>
                            <p>  "data"{"order_no": "OTHER202012180000001446"},</p>
                            <p>}</p>`,
                },

                {
                    name: '失败',
                    remark: `{
                            "code": "40500",
                            "message": "token过期!",
                            "result": "fail",
                            }`,
                    htmlStr: `<p >{</p>
                            <p >   "code": "40500",</p>
                            <p >   "message": "token过期",</p>
                            <p >   "result": "fail",</p>
                            <p >}</p>`,
                }
            ],
            // B2B充值接口   end 


            // 数据通信服务关停   start
            //请求方式
            ShutServeMethod:[{
                requestAddress: 'web/api/v2/xxtx/sim/data/mgr',
                requestType: 'post',
            }],
            //请求头
            ShutServeMethodHeader:[{
                parameter: 'Content-Type',
                beMust: '是',
                type: 'string',
                remark: '请求类型： application/json',
            }],
            //请求示例
            ShutServeExample:[
                {
                    name: '请求链接',
                    remark: `http://api.szyanyun.com/web/api/v2/xxtx/sim/data/mgr`,
                }
                ,
                {
                    name: '请求报文',
                    remark: `{
                                "type":"参数1表示开启，2表示关停",
                                "iccid":"iccid号"
                            }`,
                }
            ],
            //请求参数
            ShutrequestParameter:[
                {
                    parameter: 'type',
                    beMust: '是',
                    type: 'String',
                    remark: '参数1表示开启，2表示关停',
                },
                {
                    parameter: 'iccid',
                    beMust: '是',
                    type: 'String',
                    remark: '8986112027203084050',
                },
            ],
            //响应参数
            ShutresponseParameter:[
                {
                    parameter: 'code',
                    type: 'String',
                    remark: '状态码 200成功， 其它均为失败',
                },
                {
                    parameter: 'message',
                    type: 'String',
                    remark: '成功/失败 信息提示语',
                },
                {
                    parameter: 'result',
                    type: 'String',
                    remark: '成功为 ，失败为fail',
                },
            ],
            //响应报文
            ShutResponseMessage:[
                {
                    name: '成功',
                    remark: `{"code": "200","message": "success","result": "成功"}
                            }`,

                    htmlStr: `<p>{</p>
                            <p>   "code": "200",</p>
                            <p>   "message": "success",</p>
                            <p>   "result": "成功",</p>
                            <p>}</p>`,
                },

                {
                    name: '失败',
                    remark: `{
                            "code": "40500",
                            "message": "token过期!",
                            "result": "fail",
                            }`,
                    htmlStr: `<p >{</p>
                            <p >   "code": "40500",</p>
                            <p >   "message": "token过期",</p>
                            <p >   "result": "fail",</p>
                            <p >}</p>`,
                }
            ],
            // 数据通信服务关停   end 


            // 实时查询卡信息参数    start 
            //请求方式
            realTimeRequestMethod:[{
                requestAddress: 'web/api/v2/xxtx/sim/real/state',
                requestType: 'post',
            }],

            //请求头
            realTimeRequestHeader:[{
                parameter: 'Content-Type',
                beMust: '否',
                type: 'string',
                remark: '请求类型： application/json',
            }],

            //请求参数
            realTimeRequestParameter:[
                {
                    parameter: 'iccid',
                    beMust: '是',
                    type: 'String',
                    remark: 'ICCID号',
                },
            ],

            //请求示例
            realTimeRequestExample:[
                {
                    name: '请求链接',
                    remark: `http://api.szyanyun.com/web/api/v2/xxtx/sim/real/state`,
                }
                ,
                {
                    name: '请求报文',
                    remark: `{
                                "iccid":"iccid号"
                            }`,
                }
            ],

            //响应参数
            realTimeResponseParameter:[
                {
                    parameter: 'code',
                    type: 'String',
                    remark: '状态码 200成功， 其它均为失败',
                },
                {
                    parameter: 'message',
                    type: 'String',
                    remark: '成功/失败 信息提示语',
                },
                {
                    parameter: 'result',
                    type: 'String',
                    remark: '成功为 ，失败为fail',
                },
                {
                    parameter: 'data',
                    type: 'object',
                    remark: '成功返回响应数据，可能为空',
                },
            ],
            

            //响应参数data
            realTimeResponseDataParameter:[
                {
                    parameter: 'state',
                    type: 'int',
                    remark: '卡状态：  1：沉默期，2：正常， 3：停机，  4：测试期',
                },
            ],


            //参数pkg
            realTimeResponsePkgListParameter:[
                {
                    parameter: 'prodid',
                    type: 'String',
                    remark: '套餐id',
                },
                {
                    parameter: 'prodname',
                    type: 'String',
                    remark: '套餐名称',
                },
                {
                    parameter: 'prodinstid',
                    type: 'String',
                    remark: '套餐组id',
                },
                {
                    parameter: 'total',
                    type: 'String',
                    remark: '套餐总流量，单位M',
                },
                {
                    parameter: 'used',
                    type: 'String',
                    remark: '已使用流量，单位M',
                },
                {
                    parameter: 'left',
                    type: 'String',
                    remark: '剩余流量，单位M',
                },             
            ],




            //响应报文
            realTimeResponseMessage:[
                {
                    name: '成功',
                    remark: `{"code": "200","message": "成功","result": "success",
                                "data":{
                                    "state": 1,
                                    "pkg": [
                                        {
                                            "prodid": "I000101011213105",
                                            "prodname": "测试8元套餐",
                                            "prodinstid": "03843213129521827"
                                            "total": 100,
                                            "used": 0,
                                            "left": 100,
                                            
                                        }
                                    ]
                                }
                            }`,

                    htmlStr: `<p>{</p>
                            <p>   "code": "200",</p>
                            <p>   "message": "成功",</p>
                            <p>   "result": "success",</p>
                            <p>   "data": {</p>
                            <p>      "state": 1,</p>
                            <p>      "pkg": [</p>
                            <p>         {</p>
                            <p>            "prodid": "I000101011213105",</p>
                            <p>            "prodname": "测试8元套餐",</p>
                            <p>            "prodinstid": "03843213129521827"</p>
                            <p>            "total": 100,</p>
                            <p>            "used": 0,</p>
                            <p>            "left": 100,</p>  
                            <p>         }</p>
                            <p>      ]</p>
                            <p>   }</p>
                            <p>}</p>`,
                },

                {
                    name: '失败',
                    remark: `{
                            "code": "40010",
                            "message": "iccid不存在",
                            "result": "fail",
                            "data":null
                            }`,
                    htmlStr: `<p >{</p>
                            <p >   "code": "40010",</p>
                            <p >   "message": "iccid不存在",</p>
                            <p >   "result": "fail",</p>
                            <p >   "data":null</p>
                            <p >}</p>`,
                }
            ],
            // 实时查询卡信息参数  end


            // 1.4、B2B批量充值模板下载
            BtoBTemplaterequestMethod: [{
                requestAddress: 'web/api/v1/xxtx/download/insert/batch/template',
                requestType: 'get',
            }],
            BtoBTemplaterequestMethodHeader:[{
                parameter: 'Content-Type',
                beMust: '是',
                type: 'string',
                remark: '请求类型： application/json',
            }],

            // 1.5、B2B批量充值接口
            BtoBbatchrequestMethod: [{
                requestAddress: 'web/api/v2/xxtx/sim/insert/batch',
                requestType: 'post',
            }],
            BtoBbatchrequestMethodHeader: [{
                parameter: 'Content-Type',
                beMust: '是',
                type: 'string',
                remark: '请求类型： application/json',
            }],
            BtoBbatchrequestExample:[
                {
                    name: '请求链接',
                    remark: `http://api.szyanyun.com/web/api/v2/xxtx/sim/insert/batch`,
                }
                ,
                {
                    name: '请求报文',
                    remark: `{
                                "accountName":"用户账号",
                                "pwd":"用户密码",
                                "file":"xls表格文件（请使用模板下载接口返回的表格）"
                            }`,
                }
            ],
            //请求参数
            BtoBbatchrequestParameter:[
                {
                    parameter: 'username',
                    beMust: '是',
                    type: 'String',
                    remark: '用户名',
                },
                {
                    parameter: 'password',
                    beMust: '是',
                    type: 'String',
                    remark: '用户密码',
                },
                {
                    parameter: 'file',
                    beMust: '是',
                    type: '',
                    remark: 'xls表格文件（请使用模板下载接口返回的表格）',
                },
            ],

            //响应参数
            BtoBbatchresponseParameter:[
                {
                    parameter: 'code',
                    type: 'String',
                    remark: '状态码 200成功， 其它均为失败',
                },
                {
                    parameter: 'message',
                    type: 'String',
                    remark: '成功/失败 信息提示语',
                },
                {
                    parameter: 'result',
                    type: 'String',
                    remark: '成功success，失败为fail',
                },
                {
                    parameter: 'data',
                    type: 'object',
                    remark: '成功返回响应数据，可能为空',
                },
            ],

            responsebatchDataParameter:[
                {
                    parameter: 'success',
                    type: 'int',
                    remark: '成功数量',
                },
                {
                    parameter: 'fail',
                    type: 'int',
                    remark: '失败数量',
                },
                {
                    parameter: 'failList',
                    type: 'Array',
                    remark: '失败卡号及原因',
                },
            ],

            //响应报文
            BtoBbatchresponseMessage:[
                {
                    name: '成功',
                    remark: `{"code": "200","message": "success","result": "成功","data": "添加成功"
                            }`,

                    htmlStr: `<p>{</p>
                            <p>   "code": "200",</p>
                            <p>   "message": "success",</p>
                            <p>   "result": "成功",</p>
                            <p>   "data": {</p>
                            <p>      "fail": 4,</p>
                            <p>      "failList": [</p>
                            <p>         0: {iccid: "89860462042070063764", message: "添加充值异常，请勿重复导入"}</p>
                            <p>         1: {iccid: "89860462042070063763", message: "添加充值异常，请勿重复导入"}</p>
                            <p>         2: {iccid: "89860462042070063762", message: "添加充值异常，请勿重复导入"}</p>
                            <p>         3: {iccid: "89860462042070063761", message: "添加充值异常，请勿重复导入"}</p>
                            <p>      ]</p>
                            <p>      "success": 0</p>
                            <p>   }</p>
                            <p>}</p>`,
                },

                {
                    name: '失败',
                    remark: `{
                            "code": "40500",
                            "message": "token过期!",
                            "result": "fail",
                            }`,
                    htmlStr: `<p >{</p>
                            <p >   "code": "40500",</p>
                            <p >   "message": "token过期",</p>
                            <p >   "result": "fail",</p>
                            <p >}</p>`,
                }
            ],
        }
    },

    methods: {
        showView(currentView){
            this.currentView = currentView;
        },
        prePage() {
            let page = this.pageNum
            page = page > 1 ? page - 1 : this.pageTotalNum
            this.pageNum = page
        },

        // 下一页
        nextPage() {
            let page = this.pageNum
            page = page < this.pageTotalNum ? page + 1 : 1
            this.pageNum = page
        }
    },

    created() {

    },

}
</script>

<style lang="scss" scoped>
	#apiDoc{
        display: flex;

        .api-menu{
            flex-grow: 0;
            width: 200px;
            margin-right: 10px;

            h1{
                font-size: 16px;
                line-height: 30px;
                text-align:center;
            }
        }
        .api-content{
            flex-grow: 1;


            .requestMethod, .requestExample{
                h5{
                    margin-top: 30px;
                    line-height:30px;
                    font-weight: bold;
                }
            }
        }

	}
</style>

<style>
#apiDoc .demo-table-expand {
    padding: 0 58px;
    font-size: 0;
}
#apiDoc .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}
#apiDoc .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

#apiDoc .api-menu .el-menu-item.is-active {
    border-bottom: 1px solid #409EFF;
}

#apiDoc .api-menu .el-submenu__title {
    color: #7f8994 !important;
    font-size: 14px;
}
</style>